// extracted by mini-css-extract-plugin
module.exports = {"CopyButton":"CopyToClipboardButton_CopyButton__bAuJT","Clicked":"CopyToClipboardButton_Clicked__hPDOK","change-color":"CopyToClipboardButton_change-color__kaLsa"};